<script>
export const pageName = 'records';
export const pageRoute = '/records';
export const title = 'Altitude Records'
export const requireAuth = false

import CertFlightCardUrl from '../../resources/Cert-and-Record-flight-card-A4-v3-1.pdf'


export default {
	data() {
		return {
			CertFlightCardUrl
		}
	}
}

</script>
<template>
	<div class="container py-5">
		<h1 class="display-4 text-center mb-3">Altitude Records</h1>
		<p class="text-muted text-center mb-3">Altitude records are the highest altitudes achieved by UKRA members past and present.<br />There are four types of records, Single Motor, Cluser, Staged and Handicapped.</p>
		<p class="text-muted text-center mb-3">Come within 15% of a record to get onto the table, or break the record to take the lead!</p>
		<p class="text-muted text-center mb-3">Gain 50 XP in <a href="/model-achievement-programme">MAP</a> for a new record and 10 XP for coming within 15% or claiming a vacant record.</p>
		<p class="text-muted text-center mb-3">See <a href="https://ukra.org.uk/info/records" target="_blank">the main UKRA website <span class="fe fe-external-link"></span></a> for a full description of the rules and how to submit an attempt.</p>
		<p class="text-muted text-center mb-5">Download the <a :href="CertFlightCardUrl" target="_blank">Flight Card <span class="fe fe-download"></span></a> for use in the field.</p>

		<div class="row justify-content-center">
			<div class="col-12 col-lg-8">
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Single motor</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<p class="mb-0">Rockets flown on a single motor.</p>
							</div>
							<div class="col-auto">
								<a href="/records/single" class="btn btn-outline-primary btn-sm">View records <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Cluster</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<p class="mb-0">Rockets flown on multiple motors, ignited in parallel in a cluster configuration.</p>
							</div>
							<div class="col-auto">
								<a href="/records/cluster" class="btn btn-outline-primary btn-sm">View records <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Staged</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<p class="mb-0">Rockets flown on multiple motors, ignited one after the other in a staged configuration.</p>
							</div>
							<div class="col-auto">
								<a href="/records/staged" class="btn btn-outline-primary btn-sm">View records <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header">
						<h4 class="card-header-title">Handicapped</h4>
					</div>
					<div class="card-body">
						<div class="row">
							<div class="col">
								<p class="mb-0">Rockets built with certain design restrictions, designed to limit altitude and provide a different technical challenge.</p>
							</div>
							<div class="col-auto">
								<a href="/records/handicapped" class="btn btn-outline-primary btn-sm">View records <span class="fe fe-arrow-right-circle"></span></a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
    </div>
</template>
